import { render, staticRenderFns } from "./appsPopover.vue?vue&type=template&id=10bfa012&scoped=true"
import script from "./appsPopover.vue?vue&type=script&lang=js"
export * from "./appsPopover.vue?vue&type=script&lang=js"
import style0 from "./appsPopover.vue?vue&type=style&index=0&id=10bfa012&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bfa012",
  null
  
)

export default component.exports